export const shuffle = (a, seed = Math.random()) => {
  const arr = [...a];

  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(seed * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
};

export const last = arr => arr[arr.length - 1];

export const secondLast = arr => [...arr].reverse()[1];

export const randomElement = arr => arr[Math.round(Math.random() * (arr.length - 1))];

export const isChrome = () => /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
